const favicon = `
  <link rel="icon" type="image/x-icon" href="//alfabank.st/media/favicon_alfa-logo_32x32_common_28-08-2019.ico"/>
  <link rel="icon" type="image/png" href="//alfabank.st/media/favicon_alfa-logo_16x16_desktop_08-08-2019.png" sizes="16x16"/>
  <link rel="icon" type="image/png" href="//alfabank.st/media/favicon_alfa-logo_32x32_desktop_08-08-2019.png" sizes="32x32"/>
  <link rel="icon" href="//alfabank.st/media/favicon_alfa-logo_192x192_common_09-08-2019.png" sizes="192x192"/>
  <link rel="apple-touch-icon" href="//alfabank.st/media/favicon_alfa-logo_180x180_common_09-08-2019.png" sizes="180x180"/>
  <link rel="mask-icon" href="//alfabank.st/media/favicon_alfa-logo_128x128_common_13-08-2019.svg" color="#ef3124"/>
`;

module.exports = {
    favicon
};
